import { createLabeledMessages } from '../../../messageUtils';
const print = {
    loading: 'Načítanie dokumentu, čakajte prosím.',
    loaded: 'Dokument bol načítaný, túto záložku môžete zavrieť.'
};
export default Object.assign({}, print, createLabeledMessages(print));
